.container {
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 20px;
	padding: 10px;
	border-radius: var(--BR-M);
	background: var(--Grisos-Solids-Background, #f4f6f8);
	label {
		display: block;
		flex: 1;
		min-width: 0;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		container-type: inline-size;
		&:hover .labelText,
		&:focus-within .labelText {
			text-overflow: clip;
			width: max-content;
			max-width: none;
			transform: translateX(min(0px, calc(100cqw - 100%)));
		}
	}

	.labelText {
		display: inline-block;
		width: 100%;
		max-width: 100%;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		transform: translateX(0);
		transition: transform 1.5s linear;
		will-change: transform;
	}
	input {
		display: flex;
		height: 40px;
		padding-inline: 15px;
		justify-content: space-between;
		align-items: center;
		align-self: stretch;
		border-radius: var(--BR-M, 4px);
		border: 1px solid var(--Negres-Text-Fields-Border, #d8e0e8);
		background: var(--Blancs-Superficie-Frame, #fff);
		outline: none;
		font-size: 16px;
		line-height: 18px;
		letter-spacing: 0.04px;
		font-weight: 400;
		min-width: 100px;
		color: var(--Negres-Text-Fields-Text-Input, #000);
		&::placeholder {
			color: var(--Negres-Text-Fields-Text-Label, #555);
		}
	}

	> div {
		display: flex;
		flex-shrink: 0;
		flex-flow: row nowrap;
		gap: 10px;
	}
}
